import { createFileRoute } from "@tanstack/react-router";
import { articleGetList } from "~/features/article";
import { List } from "~/features/news";

import { Helmet } from "react-helmet-async";
import { z } from "zod";

const kiatKiatSearchSchema = z.object({
  page: z.number().catch(1),
  limit: z.number().catch(9),
  keyword: z.string().catch(""),
});

type KiatKiatSearch = z.infer<typeof kiatKiatSearchSchema>;

export const Route = createFileRoute("/_layout/article/news/")({
  validateSearch: (search: Record<string, unknown>): KiatKiatSearch => kiatKiatSearchSchema.parse(search),
  loaderDeps: ({ search: { keyword, limit, page } }) => ({ keyword, limit, page }),
  loader: ({ context: { queryClient }, deps: { page } }) =>
    queryClient.ensureQueryData(
      articleGetList({
        type: "default",
        page,
        limit: 9,
      }),
    ),
  gcTime: 0,
  shouldReload: false,
  component: () => (
    <>
      <Helmet>
        <title>News - Ecobiz</title>
      </Helmet>
      <List />
    </>
  ),
});
